<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="row">
              <div
                class="col-md-6 d-flex justify-content-start"
                style="padding-left: 2rem; padding-top: 0.5rem"
              >
                <img
                  src="@/assets/images/borneo-indobara-icon.png"
                  alt=""
                  style="width: 15%; height: auto"
                />
              </div>
              <div
                class="col-md-6 d-flex justify-content-end"
                style="padding-right: 2rem; padding-top: 0.5rem"
              >
                <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-06</p>
              </div>
            </div>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                SURAT PERNYATAAN KEBENARAN DOKUMEN
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Formulir ini digunakan untuk membuat pernyataan kebenaran
                dokumen yang dilampirkan oleh perusahaan jasa/mitra kerja di PT
                Borneo Indobara
              </p>
              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <!-- <div class="row mb-1">
                        <div class="col-md-12">
                            <p class="text-danger fst-italic fs-8 fw-bold">
                                * Wajib diisi
                            </p>
                        </div>
                    </div> -->
                <div class="row mb-2">
                  <div class="col-md-3">&nbsp;</div>
                  <div class="col-md-6">
                    <p for="nomor" class="form-label text-center fs-8 fw-bold">
                      Nomor : {{ formValues.nomor }}
                    </p>
                  </div>
                  <div class="col-md-3">&nbsp;</div>
                </div>
                <p class="mb-2 fs-8">Yang bertanda tangan di bawah ini:</p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama</label
                    >
                    <p class="fs-8">
                      {{ formValues.namaPimpinan }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <p class="fs-8">
                      {{ kontraktor.namaKontraktor }}
                    </p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan</label
                    >
                    <p class="fs-8">
                      {{ formValues.jabatanPimpinan }}
                    </p>
                  </div>
                </div>
                <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
                  MENYATAKAN:
                </p>
                <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
                  Bahwa semua dokumen yang dilampirkan untuk persyaratan
                  Pengesahan Penanggung Jawab Operasional (PJO)
                </p>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <p class="fs-8">
                      {{ kontraktor.namaKontraktor }}
                    </p>
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  adalah BENAR.<br />
                  Apabila di kemudian hari diketahui dokumen yang dilampirkan
                  adalah PALSU/TIDAK BENAR maka kami siap mempertanggungjawabkan
                  secara hukum.<br />
                  Demikian Surat Pernyataan ini kami buat untuk dipergunakan
                  sebagaimana mestinya.
                </p>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label for="tempat" class="form-label fs-8 fw-bold"
                      >Tempat</label
                    >
                    <p class="fs-8">
                      {{ formValues.tempat }}
                    </p>
                  </div>
                  <div class="col-md-3">
                    <label for="tanggal" class="form-label fs-8 fw-bold"
                      >Tanggal</label
                    >
                    <p class="fs-8">
                      {{ moment(formValues.tanggal).format("DD MMM YYYY") }}
                    </p>
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Yang Membuat Pernyataan,
                </p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                    </label>
                    <div v-if="fileTtd != ''" class="fs-8">
                      <img :src="fileTtd" style="height: 5rem" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                    </label>
                    <div v-if="fileTtd2 != ''" class="fs-8">
                      <img :src="fileTtd2" style="height: 5rem" />
                    </div>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                      >Nama Lengkap</label
                    >
                    <p class="fs-8">
                      {{ formValues.namaTTD }}
                    </p>
                    <label class="form-label fs-8 fw-bold"
                      >Pimpinan Tertinggi Perusahaan</label
                    >
                  </div>
                  <div class="col-md-6">
                    <label for="namaCalonPjo" class="form-label fs-8 fw-bold"
                      >Nama Lengkap</label
                    >
                    <p class="fs-8">
                      {{ formValues.namaTTD2 }}
                    </p>
                    <p class="fs-8 fw-bold">
                      {{ kontraktor.namaKontraktor }}
                    </p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <label for="fileAttachment" class="form-label fs-8 fw-bold"
                      >File Dokumen</label
                    >
                    <div v-if="fileAttachment != ''" class="fs-8 fw-bolder">
                      <a
                        class="text-danger pointer"
                        @click="downloadFile(fileAttachment)"
                        >Surat Pernyataan Kebenaran Dokumen.pdf</a
                      >
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="@/assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  // CMS_UPLOAD,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_SIO_GET_KEBENARAN_DOKUMEN,
  CMS_DOWNLOAD,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_SIO_GET_DASHBOARD,
  CMS_VIEW_IMAGE,
  CMS_GET_SIOID,
} from "@/constants.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url_get_kebenarandokumen = API_BASE_URL + CMS_SIO_GET_KEBENARAN_DOKUMEN;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;

const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
const max_file_size = 5; // MB

export default {
  mixins: [GlobalDataMixin],
  name: "Form4View",
  components: { DefaultLayout },
  data() {
    return {
      isLoading: true,
      refIDForm: 4,
      idForm: null,
      sioID: null,
      formValues: {
        nomor: "",
        namaPimpinan: "",
        jabatanPimpinan: "",
        perusahaan: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
        tandaTangan2: "",
        namaTTD2: "",
      },
      url_icon: "",
      fileTtd: "",
      fileTtd2: "",
      fileAttachment: "",
      validasiFile: {
        typeTtd: false,
        sizeTtd: false,
        typeTtd2: false,
        sizeTtd2: false,
        typeAtt: false,
        sizeAtt: false,
      },
      statusSio: 0,
      kontraktorid: null,
      kontraktor: [],
    };
  },
  mounted() {
    this.idForm = this.$route.params.id;
    this.getKebenaranDokumen(this.idForm);
    this.kontraktorid = this.$route.params.kontraktorid;
    this.getKontraktor(this.kontraktorid);
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log(response);
          let ret_dash = response.data.data;
          if (ret_dash.length > 0) {
            for (let i = 0; i < ret_dash.length; i++) {
              if (ret_dash[i].idForm == this.refIDForm) {
                this.idForm = ret_dash[i].id;
                this.getKebenaranDokumen(ret_dash[i].id);
              }
            }
          }
          // this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getKebenaranDokumen(idform) {
      axios
        .get(url_get_kebenarandokumen + idform, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("getKebenaranDokumen", response);
          let dt = response.data.data;

          if (dt != null) {
            this.sioID = dt.idSio;
            this.formValues.nomor = dt.nomorKontraktor;
            // this.formValues.namaPimpinan = dt.namaPemimpin;
            // this.formValues.jabatanPimpinan = dt.jabatanPemimpin;
            this.formValues.tempat = dt.tempat;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            // if(dt.tandaTangan!=''&&dt.tandaTangan!=null){
            //   this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
            // }

            // if(dt.tandaTanganPemimpin!=''&&dt.tandaTanganPemimpin!=null){
            //   this.fileTtd2 = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTanganPemimpin;
            // }

            if (dt.attachmentFile != "" && dt.attachmentFile != null) {
              this.fileAttachment = dt.attachmentFile;
            }

            // this.formValues.namaTTD = dt.namaPengesahPemimpin;
            // this.formValues.namaTTD2 = dt.namaPengesah;
            this.$nextTick(function () {
              this.getKelengkapan(this.sioID);
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKebenaranDokumen : " + error.message);
          console.error(
            "Error fetching data getKebenaranDokumen :",
            error.message
          );
        });
    },

    alertSukses() {
      Swal.fire({
        title: "Simpan Form Sukses",
        text: "Surat Pernyataan Kebenaran Dokumen Berhasil disimpan !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    handleChangeFile(refFile) {
      let file = null;

      if (refFile == "tandaTangan") {
        file = this.$refs.tandaTangan.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtd = true;
            this.validasiFile.sizeTtd = false;
            this.$refs.tandaTangan.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtd = false;
            this.validasiFile.sizeTtd = true;
            this.$refs.tandaTangan.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtd = false;
          this.validasiFile.sizeTtd = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      } else if (refFile == "tandaTangan2") {
        file = this.$refs.tandaTangan2.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtd2 = true;
            this.validasiFile.sizeTtd2 = false;
            this.$refs.tandaTangan2.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtd2 = false;
            this.validasiFile.sizeTtd2 = true;
            this.$refs.tandaTangan2.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtd2 = false;
          this.validasiFile.sizeTtd2 = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      } else if (refFile == "fileAttachment") {
        file = this.$refs.fileAttachment.files[0];
        if (file) {
          // Check file type
          if (file.type !== "application/pdf") {
            this.validasiFile.typeTtd2 = true;
            this.validasiFile.sizeTtd2 = false;
            this.$refs.tandaTangan2.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtd2 = false;
            this.validasiFile.sizeTtd2 = true;
            this.$refs.tandaTangan2.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtd2 = false;
          this.validasiFile.sizeTtd2 = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      }
    },

    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.statusSio = response.data.data.status;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getKontraktor(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log(response);
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          // this.url_icon = API_BASE_URL+CMS_VIEW_IMAGE+response.data.detailKontraktor.image;
          if (
            response.data.detailKontraktor.image != null ||
            response.data.detailKontraktor.image != ""
          ) {
            localStorage.setItem(
              "icon_kontraktor_cms",
              JSON.stringify({ icon: response.data.detailKontraktor.image })
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;

          if (
            this.formValues.namaPimpinan == null ||
            this.formValues.namaPimpinan == ""
          ) {
            this.formValues.namaPimpinan =
              ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          }
          if (
            this.formValues.jabatanPimpinan == null ||
            this.formValues.jabatanPimpinan == ""
          ) {
            this.formValues.jabatanPimpinan =
              ret_kel.jabatanAtasan == null ? "" : ret_kel.jabatanAtasan;
          }
          if (
            this.formValues.namaTTD == null ||
            this.formValues.namaTTD == ""
          ) {
            this.formValues.namaTTD =
              ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          }
          if (
            this.formValues.namaTTD2 == null ||
            this.formValues.namaTTD2 == ""
          ) {
            this.formValues.namaTTD2 =
              ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          }

          if (this.fileTtd == null || this.fileTtd == "") {
            if (ret_kel.ttdAtasan != "" && ret_kel.ttdAtasan != null) {
              this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdAtasan;
            }
          }

          if (this.fileTtd2 == null || this.fileTtd2 == "") {
            if (ret_kel.ttdPjo != "" && ret_kel.ttdPjo != null) {
              this.fileTtd2 = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdPjo;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
  },
};
</script>
